export default __webpack_public_path__ + "static/9_36-91edf1e1fc30e4309535d2b9a3b447b5.png";